<template>
  <div style="display: flex; flex-direction: column;width: inherit;overflow: auto;">
    <div class="sim-card-modal__title">
      {{ getLocalization('Order history') }}
    </div>
    <div class="sim-card-modal__table">

      <base-table
          :columns="columns"
          :wrapperFiltersData="wrapperFiltersData"
          :addModalInputData="null"
          :add-modal-input-data="false"
          :use-green-pagination-simple="true"
          :rowsPerPageText="getLocalization('Rows per page')"
          :nextText="getLocalization('Next')"
          :prevText="getLocalization('Previous')"
          :table-title="null"
          :empty-state-text="getLocalization('No orders yet')"
          :render-list-to-show="listToShowByPhone"
          :per-page-default="perPage"
          :use-green-pagination="true"
      >
        <template v-slot:base-table-row="props">
          <div v-if="props.column.field === 'service'" class="d-flex gap-2 align-items-center">
            {{ props.formattedRow[props.column.field] }}
          </div>
          <div v-else-if="props.column.field === 'id'" class="d-flex gap-2 align-items-center">
            <button @click="downloadBatch(props.formattedRow[props.column.field])" style="all: unset; cursor: pointer;">
              <img src="/img/svg/common/download.svg" alt=""/>
            </button>
            {{ props.formattedRow[props.column.field] }}
          </div>
          <template v-else>
            {{ props.formattedRow[props.column.field] }}
          </template>
        </template>
        <div slot="emptystate">
          {{ getLocalization('No orders yet') }}
        </div>
        <template v-slot:base-table-pagination-green-simple="props">
          <div class="activation-history-all__pagination">
<!--            <green-custom-pagination-->
<!--                :total="props.total"-->
<!--                :perPage="perPage"-->
<!--                :pageChanged="props.pageChanged"-->
<!--                :perPageChanged="props.pageChanged"-->
<!--            ></green-custom-pagination>-->
          </div>
        </template>
      </base-table>
    </div>
  </div>
</template>
<script>
import BaseTable from "../../../../components/table/baseTable.vue";
import BaseAdminMixin from "../../../../admin/components/mixins/BaseAdminMixin.vue";
// import GreenCustomPagination from "../../../../components/table/pagination/greenCustomPagination.vue";
import CustomPagination from "../../../../components/table/pagination/customPagination.vue";

export default {
  name: "batchMailHistory",
  components: {
    CustomPagination,
    BaseTable,
    // GreenCustomPagination
  },
  mixins: [
    BaseAdminMixin
  ],
  props: [
    'selectedPhoneNumber',
  ],
  data: function () {
    return {
      wrapperFiltersData: {
        title: "",
        filtersUrl: "/web/mail/getBatches",
        filtersUrlMethod: "get",
        startWithRequest: true,
        showCollapseFilter: false,
        showResetFilterButton: false,
        sendFilterRequestAfterSelect: true,
        filtersItems: true,
        items: {}
      },
      tableTitle: '',
      columns: [
        {
          label: this.getLocalization('ID'),
          field: 'id',
          sortable: false,
          thClass: 'custom-th-class',
        },
        {
          label: this.getLocalization('Price'),
          field: 'price',
          sortable: false,
        },
        {
          label: this.getLocalization("Total cost"),
          field: 'total_cost',
          sortable: false,
        },
        {
          label: this.getLocalization('Service'),
          field: 'service',
          sortable: false,
        },
        {
          label: this.getLocalization('Date'),
          field: 'date',
          sortable: false,
        },
        {
          label: this.getLocalization('Count'),
          field: 'count',
          sortable: false,
        },
      ],
      perPage: 250
    };
  },
  methods: {
    listToShowByPhone(list) {
      let data = [];
      for (let elem of Object.values(list['batches'] || {})) {
        data.push({
          id: elem['id'],
          price: elem['sum'],
          total_cost: elem['sum'],
          service: elem['service'],
          date: elem['created_at'],
          count: elem['count'],
        });
      }
      return data;
    },
    async downloadBatch(batchId){
      try {
        const response = await this.sendRequest('/web/mail/getActivationsByBatch','get', {
          batchId: batchId,
          format: 'txt',
        });
        const blob = new Blob([response], { type: 'text/plain' });
        const url = URL.createObjectURL(blob);

        const a = document.createElement('a');
        a.href = url;
        a.download = 'batch_' + batchId + '.txt';
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);

        URL.revokeObjectURL(url);
      } catch (error) {
        console.error('Ошибка:', error);
      }
    }
  },
}
</script>
<style>
.timer-watch {
  display: flex;
}
</style>
